module.exports = __webpack_public_path__ + "img/第4档.baf9633e.png";